import { i as P, x as l, s as f } from "../../lit-element-6iugfgmM.js";
import { e as v } from "../../custom-element-wk-AooBb.js";
import { n as p } from "../../property-BWlAHqg_.js";
import { o as S } from "../../query-assigned-elements-B8U94KLQ.js";
import { o as g } from "../../if-defined-D-RhGngI.js";
import { Localize as z } from "../../lib/I18N.js";
import _ from "../../events/PaginationChangeEvent.js";
import "../../sp-action-button-BV19roxo.js";
import "../../sp-button-DfcLwvTE.js";
import { i as b, b as y } from "../../toNumber-DCDlkXWV.js";
import { t as h } from "../../toFinite-dLr2ngf2.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var w = /^(?:0|[1-9]\d*)$/;
function x(t) {
  return t != null && function(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  }(t.length) && !function(e) {
    if (!b(e)) return !1;
    var i = y(e);
    return i == "[object Function]" || i == "[object GeneratorFunction]" || i == "[object AsyncFunction]" || i == "[object Proxy]";
  }(t);
}
function B(t, e, i) {
  if (!b(i)) return !1;
  var a = typeof e;
  return !!(a == "number" ? x(i) && function(r, n) {
    var o = typeof r;
    return !!(n = n ?? 9007199254740991) && (o == "number" || o != "symbol" && w.test(r)) && r > -1 && r % 1 == 0 && r < n;
  }(e, i.length) : a == "string" && e in i) && function(r, n) {
    return r === n || r != r && n != n;
  }(i[e], t);
}
var L = Math.ceil, E = Math.max, c = function(t, e, i) {
  return i && typeof i != "number" && B(t, e, i) && (e = i = void 0), t = h(t), e === void 0 ? (e = t, t = 0) : e = h(e), function(a, r, n) {
    for (var o = -1, m = E(L((r - a) / (n || 1)), 0), d = Array(m); m--; ) d[++o] = a, a += n;
    return d;
  }(t, e, i = i === void 0 ? t < e ? 1 : -1 : h(i));
};
const $ = P`/*!\nCopyright 2023 Adobe. All rights reserved.\nThis file is licensed to you under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License. You may obtain a copy\nof the License at http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software distributed under\nthe License is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS\nOF ANY KIND, either express or implied. See the License for the specific language\ngoverning permissions and limitations under the License.\n*/.spectrum-Pagination--explicit,.spectrum-Pagination--listing{display:flex;flex-direction:row;align-items:center}.spectrum-Pagination-textfield{width:var(--spectrum-pagination-textfield-width, var(--spectrum-global-dimension-size-600));min-width:var(--spectrum-pagination-textfield-width, var(--spectrum-global-dimension-size-600))}[dir=ltr] .spectrum-Pagination-counter{margin-left:var(--spectrum-pagination-counter-margin-left, var(--spectrum-global-dimension-size-65))}[dir=rtl] .spectrum-Pagination-counter{margin-right:var(--spectrum-pagination-counter-margin-left, var(--spectrum-global-dimension-size-65))}[dir=ltr] .spectrum-Pagination-prevButton{margin-right:var(--spectrum-pagination-page-button-margin-horizontal, var(--spectrum-global-dimension-size-65))}[dir=rtl] .spectrum-Pagination-prevButton,[dir=ltr] .spectrum-Pagination-nextButton{margin-left:var(--spectrum-pagination-page-button-margin-horizontal, var(--spectrum-global-dimension-size-65))}[dir=rtl] .spectrum-Pagination-nextButton{margin-right:var(--spectrum-pagination-page-button-margin-horizontal, var(--spectrum-global-dimension-size-65))}[dir=rtl] .spectrum-Pagination-prevButton .spectrum-Icon,[dir=rtl] .spectrum-Pagination-nextButton .spectrum-Icon{transform:scaleX(-1)}.spectrum-Pagination-pageButton:hover{background-color:var(--spectrum-pagination-page-button-background-color-hover, var(--spectrum-alias-background-color-hover-overlay))}.spectrum-Pagination-pageButton:focus{border-color:var(--spectrum-pagination-page-button-border-color-key-focus, var(--spectrum-alias-focus-color))}.spectrum-Pagination-pageButton.is-selected{background-color:var(--spectrum-pagination-page-button-background-color-down, var(--spectrum-global-color-gray-800));color:var(--spectrum-pagination-page-button-text-color-down, var(--spectrum-global-color-static-white))}.spectrum-Pagination-counter{color:var(--spectrum-alias-label-text-color, var(--spectrum-global-color-gray-700))}`, k = P`:host{--pagination-default-size: 50px}.pagination-container{display:flex;align-items:center;justify-content:center;width:100%}#next-button[disabled],#prev-button[disabled]{display:none}.separator{margin:0 10px}@media screen and (min-width: 768px){:host{--pagination-default-size: 100px}.pagination-container{min-width:625px}}`, N = { "pagination.next": "Next", "pagination.previous": "Previous" };
var A = Object.defineProperty, C = Object.getOwnPropertyDescriptor, u = (t, e, i, a) => {
  for (var r, n = a > 1 ? void 0 : a ? C(e, i) : e, o = t.length - 1; o >= 0; o--) (r = t[o]) && (n = (a ? r(e, i, n) : r(n)) || n);
  return a && n && A(e, i, n), n;
};
const q = 11, H = 4, V = 7;
let s = class extends z(f, N) {
  constructor() {
    super(...arguments), this.currentPage = 1, this.totalPages = 0, this.urlParam = null, this._onWindowResize = () => this.requestUpdate();
  }
  static get styles() {
    return [$, k];
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("resize", this._onWindowResize);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("resize", this._onWindowResize);
  }
  get buttonSize() {
    return this.cssPaginationSize === 50 ? "s" : "m";
  }
  get cssPaginationSize() {
    const t = window.getComputedStyle(this).getPropertyValue("--pagination-default-size"), e = parseInt(t);
    return isNaN(e) ? 50 : e;
  }
  get leftSegmentSize() {
    return this.cssPaginationSize === 50 ? 1 : 4;
  }
  get rightSegmentSize() {
    return this.cssPaginationSize === 50 ? 1 : 5;
  }
  get endingRangeSize() {
    return this.cssPaginationSize === 50 ? 2 : 7;
  }
  get singlePageList() {
    return this.leftSegmentSize === 1 ? this.multiPageList : this._getPageButtons(this.allPages, this.buttonSize);
  }
  get multiPageList() {
    return this._getPageButtons(this._getMultiPageList(), this.buttonSize);
  }
  get allPages() {
    return Array.from({ length: this.totalPages }).map((t, e) => e + 1);
  }
  render() {
    return l`<div class="pagination-container"><sp-button id="prev-button" size="${this.buttonSize}" static-color="black" treatment="outline" @click="${(t) => this._handlePageButtonClick(this.currentPage - 1, "prev-button", t)}" .href="${g(this._getUrlForPage(this.currentPage - 1))}" ?disabled="${!this._isPreviousButtonEnabled()}">${this.t("pagination.previous")}</sp-button>${this._isSegmentingNecessary() ? this.multiPageList : this.singlePageList} ${this._showLastPage() ? this._renderLastPageButton() : ""}<sp-button id="next-button" size="${this.buttonSize}" static-color="black" treatment="outline" @click="${(t) => this._handlePageButtonClick(this.currentPage + 1, "next-button", t)}" .href="${g(this._getUrlForPage(this.currentPage + 1))}" ?disabled="${!this._isNextButtonEnabled()}">${this.t("pagination.next")}</sp-button></div>`;
  }
  _showLastPage() {
    return !(this.totalPages - this.currentPage < this.rightSegmentSize || this.totalPages <= 11 || this.buttonSize === "s") && this.currentPage != this.totalPages;
  }
  _renderLastPageButton() {
    return l`<span aria-hidden="true">...</span><sp-action-button id="last-page-button" @click="${(t) => this._handlePageButtonClick(this.totalPages, "last-page-button", t)}" .href="${g(this._getUrlForPage(this.totalPages))}" quiet>${this.totalPages}</sp-action-button>`;
  }
  _getMultiPageList() {
    const t = this.currentPage;
    return t <= this.rightSegmentSize ? c(1, this.endingRangeSize + 1, 1) : this.totalPages - t < this.rightSegmentSize ? c(this.totalPages - this.endingRangeSize + 1, this.totalPages + 1, 1) : [...c(t - this.leftSegmentSize, t, 1), ...c(t, t + this.rightSegmentSize, 1)];
  }
  _renderPageButton(t, e) {
    return l`<sp-action-button class="page-number-button" @click="${(i) => this._handlePageButtonClick(t, "page-number-button", i)}" .href="${g(this._getUrlForPage(t))}" ?selected="${this._isCurrentPage(t)}" ?disabled="${this._isCurrentPage(t)}" quiet size="${e}">${t}</sp-action-button>`;
  }
  _getPageButtons(t, e) {
    return t.map((i) => this._renderPageButton(i, e));
  }
  _getUrlForPage(t) {
    if (!this.urlParam) return;
    const e = new URLSearchParams(window.location.search);
    return e.set(this.urlParam, t.toString()), `?${e.toString()}`;
  }
  _handlePageButtonClick(t, e, i) {
    this.dispatchEvent(new _(t, e, i));
  }
  _isCurrentPage(t) {
    return this.currentPage === t;
  }
  _isNextButtonEnabled() {
    return this.currentPage < this.totalPages;
  }
  _isPreviousButtonEnabled() {
    return this.currentPage > 1;
  }
  _isSegmentingNecessary() {
    return this.totalPages > 11;
  }
};
u([p({ type: Number })], s.prototype, "currentPage", 2), u([p({ type: Number })], s.prototype, "totalPages", 2), u([p({ type: String })], s.prototype, "urlParam", 2), u([function(t) {
  return S({ finisher: (e, i) => {
    Object.assign(e.prototype[i], t);
  } });
}({ passive: !0 })], s.prototype, "_handlePageButtonClick", 1), s = u([v("af-pagination")], s);
const X = s;
export {
  V as DEFAULT_ENDING_RANGE,
  H as DEFAULT_LEFT_SEGMENT_LENGTH,
  q as MAX_PAGES_BEFORE_SEGMENTING,
  X as default
};
//# sourceMappingURL=Pagination.js.map
